import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from '@/shared/components/ui/sonner'
import { AuthProvider } from '@/auth/context/AuthContext'
import { TeamProvider } from '@/shared/context/TeamContext'
import { AccesosRapidosProvider } from '@/shared/context/AccesosRapidosContext'
import { BreadcrumbProvider } from '@/shared/context/BreadcrumbContext'
import { ThemeProvider } from '@/shared/context/ThemeContext'
import App from './App'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider>
        <AuthProvider>
          <AccesosRapidosProvider>
            <TeamProvider>
              <BreadcrumbProvider>
                <App />
                <Toaster position="bottom-right" richColors />
              </BreadcrumbProvider>
            </TeamProvider>
          </AccesosRapidosProvider>
        </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
)
